import { render, staticRenderFns } from "./StockPositionWriteOffTable.vue?vue&type=template&id=0a8acae1&"
import script from "./StockPositionWriteOffTable.vue?vue&type=script&lang=js&"
export * from "./StockPositionWriteOffTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports